<template>
  <div class="main-body">
    <div class="header">志愿队伍</div>
    <div class="out">

      <div class="search2">
        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

<!--        <div style="float:right;">-->

<!--          <el-select v-model="commandCenterCode" placeholder="请选择机构">-->
<!--            <el-option-->
<!--                v-for="item in arr_comm"-->
<!--                :key="item.commandCenterCode"-->
<!--                :label="item.name"-->
<!--                :value="item.commandCenterCode">-->
<!--            </el-option>-->
<!--          </el-select>-->

<!--          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>-->

<!--        </div>-->

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>


        <el-table-column prop="name" label="名称" fixed></el-table-column>

        <el-table-column prop="imgPath" label="图片">
          <template slot-scope="scope">
            <el-image :src="imgHost+scope.row.imgPath" style="width: 40px;height: 40px;"/>
          </template>
        </el-table-column>

        <el-table-column prop="volunteerCount" label="志愿者人数" >
          <template slot-scope="scope">
            {{scope.row.listVolunteerTeamElderlyRel.length}}
          </template>
        </el-table-column>

        <el-table-column prop="phone" label="手机号" ></el-table-column>
        <el-table-column prop="address" label="地址" ></el-table-column>

        <el-table-column prop="createTime" :formatter="getCreateTime" label="申请时间" ></el-table-column>

        <el-table-column prop="statsu" label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>
            <el-button type="text" size="mini" @click="handleEditElderlyRel(scope.$index, scope.row)">志愿者</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_comm="arr_comm" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:arr_comm="arr_comm" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>

    <ElderlyRel ref="myElderlyRel" v-show="showModalElderlyRel" v-on:closeElderlyRel="closeElderlyRel" v-on:getList="getList"></ElderlyRel>


  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {getGovernmentCode,getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";


import Add from "./Add";
import Edit from "./Edit";
import ElderlyRel from "./ElderlyRel";


export default {
  name: "Page",
  data(){
    return{

      showModalAdd:false,
      showModalEdit:false,
      showModalElderlyRel:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,
      imgHost:this.$imgUrl,

      arr_comm:[],
      commandCenterCode: '',


      batchDialog: false,
      password:'',
      volunteerTeamCode:'',


    }
  },
  created(){
    //this.getComm();
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit,ElderlyRel,
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getComm(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CommandCenter/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_comm = response.data.data.list;
          if(this.arr_comm.length>0){
            this.commandCenterCode = this.arr_comm[0].commandCenterCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    getCreateTime(row) {
      return timefilters(row.createTime);
    },


    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    handleEditElderlyRel(index, row) {
      this.$refs.myElderlyRel.init(row);
      this.showModalElderlyRel= !this.showModalElderlyRel;
    },
    closeElderlyRel:function(){
      this.showModalElderlyRel = !this.showModalElderlyRel;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/GovPage2',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          //commandCenterCode:this.commandCenterCode,

          pageIndex:this.currentPage,
          pageSize:this.pageSize,

        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    handlePassword(index, rows) {
      this.batchDialog = true;
      this.volunteerTeamCode = rows.volunteerTeamCode
    },
    editPassword() {
      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'VolunteerTeam/EditPwd',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          volunteerTeamCode: this.volunteerTeamCode,
          password: this.password,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.batchDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>

<style scoped>

</style>
